// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inactiveEquipmentLabel__qBvQp {
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  padding: 2px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  border: 1px solid;
  width: min-content;
  color: var(--labels-filled-surface-critical);
  border-color: var(--labels-filled-surface-critical);
  cursor: pointer;
}
@media (max-width: 1024px) {
  .inactiveEquipmentLabel__qBvQp {
    font-size: 10px;
    padding: 3px;
  }
}

.tooltipLabel__bhh3Z {
  background: var(--tables-primary-row-surface-default) !important;
  box-shadow: var(--info-block-box-shadow);
  color: var(--tables-primary-row-text-main) !important;
  max-width: 180px;
  padding: 8px !important;
  opacity: 1 !important;
  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));
  border-radius: 4px !important;
  text-align: left !important;
}

.labelTitle__DM0QZ {
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  display: inline-block;
  text-transform: uppercase;
}

.separator__R1AOy {
  margin: 4px 0 8px;
  width: 100%;
  height: 1px;
  background: var(--tables-primary-row-stroke);
}

.tooltipDateRow__OUL8f {
  margin: 5px 0;
  display: flex;
  justify-content: space-between;
  color: var(--tables-primary-row-text-main);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/Sensors/components/InactiveEquipmentLabel/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,4CAAA;EACA,mDAAA;EACA,eAAA;AAzEF;AA2EE;EAhBF;IAiBI,eAAA;IACA,YAAA;EAxEF;AACF;;AA2EA;EACE,gEAAA;EACA,wCAAA;EACA,qDAAA;EACA,gBAAA;EA1CA,uBAAA;EACA,qBAAA;EACA,mDAAA;EACA,6BAAA;EACA,2BAAA;AA7BF;;AAwEA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;AArEF;;AAwEA;EACE,iBAAA;EACA,WAAA;EACA,WAAA;EACA,4CAAA;AArEF;;AAwEA;EACE,aAAA;EACA,aAAA;EACA,8BAAA;EAEA,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAtEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.inactiveEquipmentLabel {\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 14px;\n  padding: 2px 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 10px;\n  border: 1px solid;\n  width: min-content;\n  color: var(--labels-filled-surface-critical);\n  border-color: var(--labels-filled-surface-critical);\n  cursor: pointer;\n\n  @media (max-width: 1024px) {\n    font-size: 10px;\n    padding: 3px;\n  }\n}\n\n.tooltipLabel {\n  background: var(--tables-primary-row-surface-default) !important;\n  box-shadow: var(--info-block-box-shadow);\n  color: var(--tables-primary-row-text-main) !important;\n  max-width: 180px;\n\n  @include tooltip;\n}\n\n.labelTitle {\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 600;\n  display: inline-block;\n  text-transform: uppercase;\n}\n\n.separator {\n  margin: 4px 0 8px;\n  width: 100%;\n  height: 1px;\n  background: var(--tables-primary-row-stroke);\n}\n\n.tooltipDateRow {\n  margin: 5px 0;\n  display: flex;\n  justify-content: space-between;\n\n  color: var(--tables-primary-row-text-main);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inactiveEquipmentLabel": `inactiveEquipmentLabel__qBvQp`,
	"tooltipLabel": `tooltipLabel__bhh3Z`,
	"labelTitle": `labelTitle__DM0QZ`,
	"separator": `separator__R1AOy`,
	"tooltipDateRow": `tooltipDateRow__OUL8f`
};
module.exports = ___CSS_LOADER_EXPORT___;
